<template>
    <div>

        <!-- Ec breadcrumb start -->
        <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row ec_breadcrumb_inner">
                            <div class="col-md-6 col-sm-12">
                                <h2 class="ec-breadcrumb-title">{{ $t('Contact us') }}</h2>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <!-- ec-breadcrumb-list start -->
                                <ul class="ec-breadcrumb-list">
                                    <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                    <li class="ec-breadcrumb-item active">{{ $t('Contact us') }}</li>
                                </ul>
                                <!-- ec-breadcrumb-list end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec breadcrumb end -->

        <!-- Ec Contact Us page -->
        <section class="ec-page-content section-space-p">
            <div class="container">
                <div class="d-flex justify-content-center">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-lg-5">
                                <div class="ec-contact-container">

                                    <div class="alert alert-danger" v-if="error_message !== null">
                                        {{ error_message }}
                                    </div>

                                    <div class="ec-contact-form">
                                        <form @submit.prevent="create">

                                            <div class="ec-contact-wrap mb-3">
                                                <label>{{ $t('Name') }}</label>
                                                <input type="text"
                                                       :class="{ 'is-invalid' : isInvalid('name')}"
                                                       v-model="item.name"
                                                       required />
                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('name')">
                                                    {{  isInvalid('name') }}
                                                </div>
                                            </div>

                                            <div class="ec-contact-wrap mb-3">
                                                <label>{{ $t('Phone') }}</label>
                                                <input type="text" dir="ltr"
                                                       :class="{ 'is-invalid' : isInvalid('phone')}"
                                                       v-model="item.phone"
                                                       required />
                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('phone')">
                                                    {{  isInvalid('phone') }}
                                                </div>
                                            </div>

                                            <div class="ec-contact-wrap mb-3">
                                                <label>{{ $t('Email') }}</label>
                                                <input type="email" dir="ltr" id="email" class="form-control" v-model="item.email"
                                                       :class="{ 'is-invalid' : isInvalid('email')}">

                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('email')">
                                                    {{  isInvalid('email') }}
                                                </div>
                                            </div>

                                            <div class="ec-contact-wrap mb-3">
                                                <label>{{ $t('Purpose of connection') }}</label>
                                                <select class="form-control border form-select " id="purpose" v-model="item.purpose"
                                                        :class="{ 'is-invalid' : isInvalid('purpose')}">
                                                    <option value="" selected="" disabled="" hidden="" style="display: none;"></option>
                                                    <option v-for="(value,key) in form_options?.purpose" :value="key" >{{ value }}</option>
                                                </select>
                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('purpose')">
                                                    {{  isInvalid('purpose') }}
                                                </div>
                                            </div>

                                            <div class="ec-contact-wrap mb-3">
                                                <label>{{ $t('Importance of communication') }}</label>
                                                <select class="form-control border form-select " id="importance" v-model="item.importance"
                                                        :class="{ 'is-invalid' : isInvalid(importance)}">
                                                    <option value="" selected="" disabled="" hidden="" style="display: none;"></option>
                                                    <option v-for="(value,key) in form_options?.importance" :value="key" >{{ value }}</option>
                                                </select>
                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('importance')">
                                                    {{  isInvalid('importance') }}
                                                </div>
                                            </div>

                                            <div class="ec-contact-wrap mb-3">
                                                <label>{{ $t('Message') }}</label>

                                                <textarea v-model="item.message" id="message" class="form-control"
                                                          :class="{ 'is-invalid' : isInvalid('message')}"></textarea>

                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('message')">
                                                    {{  isInvalid('message') }}
                                                </div>
                                            </div>



                                            <span class="ec-contact-wrap ec-contact-btn">
                                                <button class="btn btn-primary" type="submit">
                                                    {{ $t('Send Message') }}
                                                </button>
                                            </span>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <div class="ec_contact_map">
                                    <div class="ec_map_canvas">
                                        <iframe id="ec_map_canvas"  :src="main?.settings?.map_url"></iframe>
                                    </div>
                                </div>
                                <div class="ec_contact_info">
                                    <h1 class="ec_contact_info_head">{{ $t('Contact Information') }}</h1>
                                    <ul class="align-items-center">

                                        <li class="ec-contact-item mb-3" v-for="data in contact_data?.data" :key="item.id">
    <!--                                        <i class="ecicon eci-map-marker" aria-hidden="true"></i>-->
                                            <a class="contact-detail-box" :href="data?.href">
                                                <i :class="data?.icon"></i>
                                                <span>{{ data?.name }} :</span>
                                                {{ data?.value }}
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();

import alertErrors from "../handling/alert-errors";

export default {
    props:['main'],
    components: {
        alertErrors,
    },
    data() {
        return {
            contact_data: [],
            form_options: {},
            item: {},
            validationErrors: null,
            error_message: null,
        }
    },
    created() {


        const id = toast.info(this.$t('getting options ...'),{ icon: 'fa-light fa-filter-list'  });

        const that = this;

        axios.get('contact_us/create').then(response => {
            toast.dismiss(id);
            this.form_options = response.data.elements;
        }) .catch(function (error) {
            toast.dismiss(id);
            if (error.response) {
                that.validationErrors = error.response.data.errors ;
            }
        });

        this.getResults();


    },
    methods: {
        isInvalid( name ) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        getResults () {
            const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });
            axios.get('contacts_data').then(response => {
                toast.dismiss(id);
                this.contact_data = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
        create() {

            const id = toast.info(this.$t('Adding content...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;
            this.error_message = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('contact_us',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.item = {};
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    that.error_message = error.response.data.message ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        }
    }
}
</script>
